import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import * as MeetingService from "../../../../services/MeetingService";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";
import {
  ButtonAction,
  ButtonClose,
  Icon,
  Option,
  DocumentLink,
} from "./meetingList.styled";
import { Can, AbilityContext } from "../../../security/permissions/Can";
import { USER_PERMISSIONS } from "../../../security/permissions/rolesPermission";
import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";
import {
  ShowAlertDialog,
  PaginateList,
} from "@de-prado-dev/react-component-library";
import moment from "moment-timezone";
import { MONTHS } from "../../../../constants/index";
import { getRoleSelector } from "../../../../store/selectors/authSelector";
import { useSelector } from "react-redux";

const MeetingListContainer = ({ filters, sortBy }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const [forceRefresh, setForceRefresh] = useState(false);
  const context = useContext(AbilityContext);
  const role = useSelector(getRoleSelector);

  const columns = [
    {
      header: t("forms.meeting.table.heads.name"),
      accessorKey: "course.name",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.meeting.table.heads.farm"),
      accessorKey: "center.name",
      cell: (info) => info.getValue(),
    },
    // {
    //   header: t("forms.meeting.table.heads.month"),
    //   accessorKey: "month",
    //   cell: (info) => moment(info.getValue()).format("DD-MM-yyyy"),
    // },

    {
      header: t("forms.meeting.table.heads.monthYear"),
      accessorKey: "month",
      cell: (info) => {
        const row = info.row.original;
        const month = MONTHS.find((pl) => pl.code === row.month);
        const year = row.year;
        return <div>{`${t(month?.label)} / ${year}`}</div>;
      },
    },
    {
      header: t("forms.meeting.table.heads.sessions"),
      accessorKey: "session",
      cell: (info) => {
        const row = info.row.original;
        return <div>{row.session?.length || 0}</div>;
      },
    },
    // {
    //   header: t("forms.meeting.table.heads.endDate"),
    //   accessorKey: "endDate",
    //   cell: (info) => moment(info.getValue()).format("DD-MM-yyyy"),
    // },
    {
      Header: t(""),
      accessorKey: " ",
      cell: (info) => renderAction(info.row.original),
    },
  ];

  const goToEdit = (uuid) => {
    navigate(`/adm/meeting/form/update/${uuid}`);
  };

  const renderAction = (data) => {
    return (
      <div className="text-center">
        <Can do={USER_PERMISSIONS.VIEW_MEETING}>
          <ButtonAction
            onClick={() =>
              navigate(PATHS.LIST_SESSION, {
                state: { filters: { meetingUuid: data.uuid } },
              })
            }
            title={t("forms.meeting.buttons.goTo")}
          >
            <i className="fa-solid fa-person-chalkboard"></i>
          </ButtonAction>
        </Can>
        <Can do={USER_PERMISSIONS.EDIT_MEETING}>
          <ButtonAction
            onClick={() => goToEdit(data.uuid)}
            type="button"
            title={t("forms.meeting.buttons.edit")}
          >
            <i className="fa-regular fa-pen-to-square"></i>
          </ButtonAction>
        </Can>
        <Can do={USER_PERMISSIONS.DELETE_MEETING}>
          <ButtonAction
            onClick={() => showDialogOnDelete(data.uuid)}
            type="button"
            title={t("forms.meeting.buttons.delete")}
          >
            <Icon className="fa-solid fa-trash-can"></Icon>
          </ButtonAction>
        </Can>
        {data.course?.documents?.[0]?.url && (
          <DocumentLink
            href={data.course.documents[0].url}
            download
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fas fa-download"></i>
          </DocumentLink>
        )}
      </div>
    );
  };

  const showDialogOnDelete = (uuid) => {
    const okAction = async () => {
      await MeetingService.deleteMeeting(uuid).then((result) => {
        if (result && result === "OK") {
          setForceRefresh(true);
        }
      });
    };

    const cancelAction = () => {};

    ShowAlertDialog(
      t("forms.form.dialog.remove.title"),
      t("forms.form.dialog.remove.text"),
      "warning",
      true,
      t("forms.form.dialog.remove.buttonOk"),
      false,
      okAction,
      t("forms.form.dialog.remove.buttonNo"),
      cancelAction
    );
  };

  const listData = async (filter) => {
    if (sortBy) {
      filter.sort = sortBy;
    } else {
      filter.sort = "-date";
    }
    const result = await MeetingService.listFilter(filter);
    return result;
  };

  const hideColumn = {};
  let resize = null;

  if (deviceSize < SIZES.md) {
    // hideColumn.itemCode = false;
    resize = false;
  } else if (deviceSize === SIZES.md) {
    // hideColumn.itemCode = false;
  }

  return (
    <PaginateList
      refresh={forceRefresh}
      filters={filters}
      columns={columns}
      toList={listData}
      hideColum={hideColumn}
      resize={resize}
      resetRefresh={() => setForceRefresh(false)}
    ></PaginateList>
  );
};

MeetingListContainer.propTypes = {
  filters: PropTypes.object,
};

export default MeetingListContainer;
